import axios from "axios";
import { url } from "../baseUrl";

export const RulesetStore = {
  state: {
    all: []
  },
  mutations: {
    getallruleset(state, data) {
      state.all = data.map((item, index) => ({
        index: index + 1 + ".",
        id: item.id,
        title: item.description,
        description: item.detail,
        riskrating: item.riskrating
      }));
    }
  },
  actions: {
    getAllRuleset(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/rulesets/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getallruleset", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
